var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 275,
    viewBox: "0 0 275 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 137.5,
    cy: 137.5,
    r: 137.5,
    fill: "#3B3D4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5714 73.6606C83.0486 73.6606 78.5714 78.1378 78.5714 83.6606V186.429C78.5714 191.951 83.0486 196.429 88.5714 196.429H107.857C113.38 196.429 117.857 191.951 117.857 186.428V83.6606C117.857 78.1378 113.38 73.6606 107.857 73.6606H88.5714ZM162.232 73.6606C156.709 73.6606 152.232 78.1378 152.232 83.6606V186.429C152.232 191.951 156.709 196.429 162.232 196.429H181.518C187.041 196.429 191.518 191.951 191.518 186.428V83.6606C191.518 78.1378 187.041 73.6606 181.518 73.6606H162.232Z",
    fill: "#BEDFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.d62f0d81772dda8f1ad3cba8eccaf712.svg";
export { ForwardRef as ReactComponent };